/**
 * Login Pagina
 */

import { useState, FormEvent } from 'react';
import { authService } from '../../services/auth.service';
import './Auth.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await authService.login({ username, password });
      
      // Complete page reload is the most reliable way to ensure clean state
      setTimeout(() => {
        window.location.href = window.location.origin + '/';
      }, 100);
      
    } catch (err: any) {
      setError(err.message || 'Login mislukt. Controleer je gebruikersnaam en wachtwoord.');
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <div className="auth-header">
          <h1>
            <span style={{ color: '#e06c00' }}>Buro</span>
            <span style={{ color: '#1f6fd0' }}>42</span>
          </h1>
          <p>Inloggen om verder te gaan</p>
        </div>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="username">Gebruikersnaam</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoFocus
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Wachtwoord</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <button type="submit" className="btn-login" disabled={loading}>
            {loading ? 'Inloggen...' : 'Inloggen'}
          </button>
        </form>

        <div className="auth-footer">
          <p>Buro42</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
